import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { RouterLink } from '@angular/router';

@Component({
  imports: [
    RouterLink
  ],
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
  private vvcrUrl: string = environment.vvcrUrl

  public goToLogin(): void {
    window.open(this.vvcrUrl + '/login', "_blank");
  }

  public goToSupport(): void {
    window.open('https://support.vvcr.tv/', "_blank");
  }

  public goToContact(): void {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSc8sUQwkqJXUzJlbRCCVK-NDvMa39FtRsbaKrLK0oL-1J__0g/viewform?embedded=true', "_blank");
  }

}
